import GradientBg from "@/components/common/GradientBg";
import { BRAND } from "@/branding.config";

export default function Terms() {
  return (
    <div className="relative">
      <GradientBg variant="soft" />
      <section className="relative mx-auto max-w-3xl px-6 pt-28 pb-32">
        <div className="text-xs uppercase tracking-[0.2em] text-primary font-bold">Legal</div>
        <h1 className="mt-3 text-5xl font-black tracking-tight">Terms of Service</h1>
        <p className="mt-3 text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
        <div className="mt-10 space-y-6 text-muted-foreground leading-relaxed">
          <p>By using {BRAND.app_name} you agree to these terms. Please read them carefully.</p>
          <h2 className="text-xl font-bold text-foreground">Acceptable use</h2>
          <p>You may not use {BRAND.app_name} for illegal activities, spam, malware distribution, or to interfere
          with other customers' access to the service.</p>
          <h2 className="text-xl font-bold text-foreground">Billing</h2>
          <p>Invoices are due upon receipt. Late payment may result in service suspension. Refunds are pro-rated. Billing enquiries: <a className="text-primary hover:underline" href={`mailto:${BRAND.billing_email}`}>{BRAND.billing_email}</a>.</p>
          <h2 className="text-xl font-bold text-foreground">SLA</h2>
          <p>We provide a 99.99% monthly uptime SLA on all production tiers, with service credits per our SLA policy.</p>
          <h2 className="text-xl font-bold text-foreground">Limitation of liability</h2>
          <p>To the maximum extent permitted by law, our aggregate liability is limited to fees paid in the previous 12 months.</p>
          <h2 className="text-xl font-bold text-foreground">Governing law</h2>
          <p>These terms are governed by the laws applicable at {BRAND.legal_company_name}'s registered office ({BRAND.company_address}).</p>
        </div>
      </section>
    </div>
  );
}
